import React from 'react';
import {
  Form,
  LabelInput,
} from '../../common/components/form';
import Button from '../../../ui/button/Button';

import { Localize } from '../../../locale/localization';

const ForgotPasswordForm = (props) => {
  const {
    enabled,
    onSubmit,
    onCancel,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    email,
  } = props;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      <LabelInput
        label="Käyttäjätunnuksesi (sähköpostiosoite)"
        name="email"
        type="email"
        value={email}
        error={errors['email'] && touchedFields.indexOf('email') > -1}
        errorMessage={errors['email']}
        onChange={onInputChange}
      />
      <footer>
        <Button theme="light" onClick={onCancel}>{Localize('action.cancel')}</Button>
        <Button
          disabled={!isValid || !enabled}
          type="submit"
          icon="#chevron-right"
          iconRight={true}
        >
          {Localize('password.restore')}
        </Button>
      </footer>
    </Form>
  );
};

export default ForgotPasswordForm;


// WEBPACK FOOTER //
// ./src/modules/user/components/ForgotPasswordForm.js